import {Dispatch, default as React} from 'react';
import {Action} from './base/fsa/createAction';

import intercomIcon from './assets/images/icons/intercom.png';
import scenarioIcon from './assets/images/icons/scenario.png';
import sensorIcon from './assets/images/icons/sensor.png';
import alarmIcon from './assets/images/icons/alarm.png';
import cameraIcon from './assets/images/icons/camera.png';
import {RouteComponentProps} from 'react-router';
import {CameraScreen} from './screens/CameraScreen';
import {AlarmScreen} from './screens/AlarmScreen';
import {IntercomScreen} from './screens/IntercomScreen';
import {MediaCreateScreen} from './screens/MediaCreateScreen';
import {LoginScreen} from './screens/LoginScreen';
import {IntercomModel} from './types/intercom';
import {setIntercomInfoAction, setIntercomStatusAction} from './store/control/actions';
import {SettingsRoutes} from './screens/Settings';
import {MainScreen} from './screens/MainScreen';
import {UserSettingsScreen} from './screens/SettingsScreen/UserSettingsScreen';
import {ScenarioScreen} from './screens/ScenarioScreen';
import {SensorScreen} from './screens/SensorScreen';
import {PageScreen} from './screens/PageScreen';
import {MediaListScreen} from './screens/MediaListScreen';

export type RouteDefinition = {
    name?: string;
    routerLink?: string;
    exact?: boolean;
    component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
};

export const getRouteList = (): RouteDefinition[] => [
    {
        routerLink: '/',
        component: MainScreen,
        exact: true,
    },
    {
        routerLink: '/login',
        component: LoginScreen,
        exact: true,
    },
    {
        name: 'İNTERKOM',
        routerLink: '/intercom',
        component: IntercomScreen,
        exact: true,
    },
    {
        name: 'KAMERA',
        routerLink: '/camera',
        component: CameraScreen,
        exact: true,
    },
    {
        name: 'ALARM',
        routerLink: '/alarm',
        component: AlarmScreen,
        exact: true,
    },
    {
        name: 'SENARYO',
        routerLink: '/scenario',
        component: ScenarioScreen,
        exact: true,
    },
    {
        name: 'SENSÖRLER',
        routerLink: '/sensor',
        component: SensorScreen,
        exact: true,
    },

    {
        name: 'MEDYA EKLE',
        routerLink: '/media-remote/create',
        component: MediaCreateScreen,
    },
    ...SettingsRoutes,
    {
        name: 'AYARLAR',
        routerLink: '/settings',
        component: UserSettingsScreen,
    },
    {
        name: 'Page',
        routerLink: '/page/:id',
        component: PageScreen,
    },
    {
        name: 'MEDYA',
        routerLink: '/media-remote',
        component: MediaListScreen,
    },
    // {
    //     name: 'PERDE',
    //     iconUrl: curtainIcon,
    //     routerLink: '/curtain',
    //     component: CurtainScreen,
    //     showOnSidebar: true,
    //     exact: true,
    // },
    // {
    //     name: 'AYDINLATMA',
    //     iconUrl: lampIcon,
    //     routerLink: '/light',
    //     component: LightScreen,
    //     showOnSidebar: true,
    //     exact: true,
    // },
    // {
    //     name: 'PRİZ',
    //     iconUrl: plugIcon,
    //     routerLink: '/plug',
    //     component: PlugScreen,
    //     showOnSidebar: true,
    //     exact: true,
    // },
    // {
    //     name: 'KLİMA',
    //     iconUrl: airConditionerIcon,
    //     routerLink: '/air',
    //     component: AirScreen,
    //     showOnSidebar: true,
    //     exact: true,
    // },
    // {
    //     //     name: 'SİSTEM',
    //     //     iconUrl: contactorIcon,
    //     //     routerLink: '/system',
    //     //     component: SystemScreen,
    //     //     showOnSidebar: true,
    //     //     exact: true,
    //     // },
    //     // {
    //     //     name: 'ISITMA',
    //     //     iconUrl: temperatureIcon,
    //     //     routerLink: '/temperature',
    //     //     component: TemperatureScreen,
    //     //     showOnSidebar: true,
    //     //     exact: true,
    //     // },

];
